/* eslint-disable no-console */
import { getCognitoAccessToken } from "src/services/Api";
import { GET_QUICK_APPLY_CRITERIA } from "../../services/GraphQL/graph.query";
import { graphqlRequest } from "../../services/GraphQL/GraphQL";

export const FETCH_QUICK_APPLY_CRITERIA_REQUEST = "FETCH_QUICK_APPLY_CRITERIA_REQUEST";
export const fetchQuickApplyCriteriaRequest = (payload) => ({
  type: FETCH_QUICK_APPLY_CRITERIA_REQUEST,
  payload,
});

export const FETCH_QUICK_APPLY_CRITERIA_SUCCESS = "FETCH_QUICK_APPLY_CRITERIA_SUCCESS";
export const fetchQuickApplyCriteriaSuccess = (payload) => ({
  type: FETCH_QUICK_APPLY_CRITERIA_SUCCESS,
  payload,
});

export const FETCH_QUICK_APPLY_CRITERIA_FAILURE = "FETCH_QUICK_APPLY_CRITERIA_FAILURE";
export const fetchQuickApplyCriteriaFailure = (payload) => ({
  type: FETCH_QUICK_APPLY_CRITERIA_FAILURE,
  payload,
});

export const fetchQuickApplyCriteria = (payload) => async (dispatch) => {
  const accessToken = await getCognitoAccessToken();
  dispatch(fetchQuickApplyCriteriaRequest());
  try {
    const { getQuickApplyCriteria } = await graphqlRequest(
      GET_QUICK_APPLY_CRITERIA,
      payload,
      accessToken
    );
    console.log("getQuickApplyCriteria", getQuickApplyCriteria);
    if (getQuickApplyCriteria.status === 200) {
      dispatch(fetchQuickApplyCriteriaSuccess(getQuickApplyCriteria?.criteria));
      return getQuickApplyCriteria?.criteria;
    }
    dispatch(fetchQuickApplyCriteriaFailure(getQuickApplyCriteria?.userMessage));
    return getQuickApplyCriteria?.criteria;
  } catch (error) {
    dispatch(fetchQuickApplyCriteriaFailure(error));
    return null;
  }
};
